export const XAnonymousResourceHeader = 'X-Anonymous-Resource';
export const AuthorizationHeader = 'Authorization';
